import { Controller } from "@hotwired/stimulus"

/** Dirty-state for profile quick-edit (bio/location) or settings (photo/sports). */
export default class extends Controller {
  static targets = ["submit", "bio", "location", "file", "fileName", "removeAvatar", "sports"]
  static values = {
    initialBio: String,
    initialLocation: String,
    initialSportsJson: String
  }

  connect() {
    this.updateDirty()
  }

  fileSelected() {
    const scrollY = window.scrollY

    if (this.hasFileNameTarget) {
      const name = this.fileTarget.files?.[0]?.name
      this.fileNameTarget.textContent = name || ""
      this.fileNameTarget.classList.toggle("hidden", !name)
    }

    this.updateDirty()

    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY)
    })
  }

  updateDirty() {
    if (!this.hasSubmitTarget) return

    let dirty = false

    if (this.hasBioTarget) {
      dirty ||= this.bioTarget.value !== this.initialBioValue
    }
    if (this.hasLocationTarget) {
      dirty ||= this.locationTarget.value !== this.initialLocationValue
    }

    const currentSports = this.collectSports()
    const initialSports = this.initialSportsSorted()
    if (this.hasSportsTarget || this.initialSportsJsonValue) {
      dirty ||= JSON.stringify(currentSports) !== JSON.stringify(initialSports)
    }

    if (this.hasFileTarget && this.fileTarget.files?.length > 0) dirty = true
    if (this.hasRemoveAvatarTarget && this.removeAvatarTarget.checked) dirty = true

    this.submitTarget.disabled = !dirty
    this.submitTarget.classList.toggle("opacity-50", !dirty)
    this.submitTarget.classList.toggle("cursor-not-allowed", !dirty)
  }

  initialSportsSorted() {
    try {
      const arr = JSON.parse(this.initialSportsJsonValue || "[]")
      return [...arr].sort()
    } catch {
      return []
    }
  }

  collectSports() {
    const vals = []
    const sportsRoot = this.hasSportsTarget ? this.sportsTarget : this.element
    sportsRoot.querySelectorAll(".sport-chip__input, input[type=\"checkbox\"][name=\"user_setting[favorite_sports][]\"]").forEach((cb) => {
      if (cb.checked) vals.push(cb.value)
    })
    return vals.sort()
  }
}
